import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

import { Funding } from '@finley-technologies/finley-types';

import { Typography } from 'packages/common-frontend/components/Typography';

type InterestType = Funding.LoanMechanics['loans'][number]['interest'];

type InterestProps = {
  interest: InterestType;
};

export const Interest = ({ interest }: InterestProps) => {
  return (
    <>
      <Typography variant="section-subtitle">Interest</Typography>
      <TableContainer w="100%">
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Value</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Day count convention</Td>
              <Td>{interest.calculation.dayCountConvention}</Td>
            </Tr>
            {/* @jendevelops TODO display period config */}
            {/* <Tr>
            <Td>End date config</Td>
            <Td>{interest.period.endDateConfig}</Td>
          </Tr> */}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
